
const envApiBase = {
  local: process.env.REACT_APP_API_URL_LOCAL as string,
  test: '/api/v1/',
  prod: '/api/v1/'
};
const envApiLinkTiktokBase = {
  local: 'https://viralsauce.ai/',
  test: 'https://viralsauce.ai/',
  prod: 'https://viralsauce.ai/'
};

const envNodeApiBase = {
  prod: "https://viralsauce.ai/api/nodev2/",
  test: "http://52.233.82.211:38093/api/nodev2/",
  local: "http://52.233.82.211:38093/api/nodev2/",
  // local: "http://localhost:8080/api/nodev2/",
}

export const deployedEnv = () => {
  switch (window.location.hostname) {
    case 'www.viralsauce.ai':
    case 'viralsauce.ai':
      return 'prod';
    case 'www.waywardlink.com':
    case 'waywardlink.com':
    case '52.233.82.211':
      return 'test';
    default:
      return 'local';
  }
};

export const envResolverAPIURL = () => {
  const env = deployedEnv();
  return envApiBase[env];
};

export const envResolverNodeAPIURL = () => {
  const env = deployedEnv();
  switch (env) {
    case 'prod':
    case "test":
      return envNodeApiBase[env];
    default:
      return envNodeApiBase['local'];
  } 
}

export const envResolverTkAPIURL = () => {
  const env = deployedEnv();
  switch (env) {
    case 'prod':
    case "test":
      return envApiLinkTiktokBase[env];
    default:
      return envApiLinkTiktokBase['local'];
  }
};

export const isEnvProduction = () => {
  return deployedEnv() === 'prod' ? true : false;
};

export function isIOSSafari() {
  const userAgent = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
  return isIOS && isSafari;
}

export function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor;
  let mobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
  if(!mobile) mobile = window.innerWidth < 460;
  return mobile;
}

export const TRACKING_ID = "G-8YEPEP6SDD";

export const TIKTOK_SHOP_LINK = "https://shop.tiktok.com/alliance/creator/auth?app_key=6g1hrp0v1qqfm&state=123"